export default __webpack_public_path__ + "static/media/ilustracao-mulher-apaixonada.03187d11.svg";